import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';

export interface NotesDialogData {
    notes: string;
    appName?: string;
}

@Component({
    selector: 'app-notes-dialog',
    templateUrl: './notes-dialog.component.html',
    styleUrls: ['./notes-dialog.component.css'],
    imports: [MaterialModule]
})
export class NotesDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<NotesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: NotesDialogData
    ) { }

    onClose(): void {
        this.dialogRef.close();
    }
}
